module.exports = __webpack_public_path__ + "media/src/application/media/route_3-08930a203db61b69e0bd1219126980fc.png";